import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { create } from 'zustand';
import { createJSONStorage, persist, type StateStorage } from 'zustand/middleware';

/** Evita cache do createJSONStorage apontar para dummyStorage após SSR. */
const sidebarWebStorage: StateStorage = {
  getItem: (name) => {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(name);
  },
  setItem: (name, value) => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(name, value);
  },
  removeItem: (name) => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(name);
  },
};

interface SidebarState {
  isOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  isCollapsed: boolean;
  toggleCollapsed: () => void;
}

type SidebarPersisted = Pick<SidebarState, 'isCollapsed'>;

const sidebarStorage =
  Platform.OS === 'web'
    ? createJSONStorage<SidebarPersisted>(() => sidebarWebStorage)
    : createJSONStorage<SidebarPersisted>(() => AsyncStorage);

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isOpen: false,
      openSidebar: () => set({ isOpen: true }),
      closeSidebar: () => set({ isOpen: false }),
      isCollapsed: false,
      toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
    }),
    {
      name: 'sidebar-storage',
      storage: sidebarStorage,
      partialize: (state) => ({
        isCollapsed: state.isCollapsed,
      }),
    },
  ),
);

export const useSidebar = useSidebarStore;
